import { faEdit, faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import ContractorDelete from "./ContractorDelete";
import ContractorDetailPopup from "./ContractorDetailPopup";
// import CustomerDetailPopup from "./CustomerDetailPopup";

const ContractorActionButton = ({ id, handleDelete }) => {
  const [showDelete, setShowDelete] = useState(false);
  const [showView, setShowView] = useState(false);
  const params = useParams();
  const businessId = params?.business_id;

  const toggleShowModal = () => {
    setShowView(!showView);
  };

  const toggleDeleteModal = () => {
    setShowDelete(!showDelete);
  };
  return (
    <>
      <span>
        <FontAwesomeIcon
          onClick={toggleShowModal}
          icon={faEye}
          size="1x"
          data-toggle="modal"
          data-target="#contractorDetail"
        />
        <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
        <Link to={`/business/${businessId}/edit-contractor?id=${id}`}>
          <FontAwesomeIcon icon={faEdit} size="1x" />
        </Link>
        <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
        <FontAwesomeIcon
          onClick={toggleDeleteModal}
          icon={faTrash}
          size="1x"
          data-toggle="modal"
          data-target="#deleteContractor"
        />
      </span>

      {showDelete && (
        <ContractorDelete
          contractorId={id}
          toggleDeleteModal={toggleDeleteModal}
          handleDelete={handleDelete}
          showDelete={showDelete}
        />
      )}

      {showView && (
        <ContractorDetailPopup
          contractorId={id}
          toggleShowModal={toggleShowModal}
          showView={showView}
        />
      )}
    </>
  );
};

export default ContractorActionButton;
